module.exports = __webpack_public_path__ + "static/img/pay_pal.88ae2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay/pay_pal.png
// module id = 2N/p
// module chunks = 0